import React from 'react'

import FieldUsers from "../../users/users"
import UserIcon from "../../../../gd-ui/icon/user/user"

type FieldMultiselectViewProps = {
    field           : FieldUsers
    model           : any
    className?      : string
    options?        : any
    configOptions?  : any
    onClick?        : onClick
}

export default function FieldAssignees_View(props:FieldMultiselectViewProps) {

    const value         = _.get(props.model, props.field.fieldId, null)
    const valueOptions  = props.field._getOptions(value)

    if (!valueOptions) {
        const showIcon = _.get(props.configOptions, 'showIcon', true)
        let label = props.field.placeholder

        // check if all values option is enabled
        if (!!props.field.allValuesOption && !props.options) {
            label = props.field.allValuesOptionLabel;
        }

        return (
            <div className={Classes("ui5-txt-no-accent-default min-w-125", props.className)}>
                {showIcon && _.get(props.field.components, 'ValueIcon', false)}
                {label}
            </div>
        )
    } else {
        return (
            <React.Fragment>
                <div className={Classes("ui5-txt-default fl-ac max-w-300 fl-wrap m-t-4 m-b-4", props.className)}
                     onClick={props.onClick}>
                    {_.map(valueOptions, (option) => {
                        const user = gd.session.users.get(option.value)!
                        return (
                            <div key={option.value}
                                 className="flex-row-left-center w-100-percent txt-truncate m-t-5">
                                <UserIcon className="m-r-5" size="22" userId={user.id}/>
                                <div className="ui5-txt-default txt-truncate">{user.name}</div>
                            </div>
                        )
                    })}
                </div>
            </React.Fragment>
        )
    }
}
